export default __webpack_public_path__ + "static/media/gametaverse_background.a0b3452f.jpeg";